import { render, staticRenderFns } from "./bindAliPay.vue?vue&type=template&id=3abe1052&scoped=true&"
import script from "./bindAliPay.vue?vue&type=script&lang=js&"
export * from "./bindAliPay.vue?vue&type=script&lang=js&"
import style0 from "./bindAliPay.vue?vue&type=style&index=0&id=3abe1052&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe1052",
  null
  
)

export default component.exports